export type TutorialStepMobile = {
    selector?: string;
    message: string;
    image?: string;
    isMustClick?: boolean;
    isMustClickWithNoAction?: boolean;
    timeOut?: number;
    hidePopover?: boolean;
    title?: string;
    elementMustClickBeforeNext?: string;
    requiredDrawerOpen?: string;
    preExecuteWhenNext?: () => void;
    preExecuteWhenPrev?: () => void;
};

export const DrawerIdMobile = {
    MESSAGE: "message",
    INTERACTION: "interaction",
    HAMBUGER: "hamburger"
} as const;
//#region Drawer State Checkers
export const isMessageBoxOpen = () => document.querySelector('.openMessageBoxButton')?.getAttribute('aria-pressed') === 'true';
export const isInteractionOpen = () => document.querySelector('.openInteractionBoxButton')?.getAttribute('aria-pressed') === 'true';
export const isHamburgerOpen = () => !document.getElementById('mobile-menu-drawer')?.classList.contains('MuiModal-hidden');
export const forceClick = (el: HTMLElement | null) => {
    if (!el) return;
    const prev = el.style.pointerEvents;
    el.style.pointerEvents = "auto";
    el.click();
    // Restore original value after React processes the click in the next microtask
    Promise.resolve().then(() => {
        el.style.pointerEvents = prev;
    });
};
export const openHamburger = () => {
    if (!isHamburgerOpen()) {
        forceClick(document.getElementById('mobile-menu-button') as HTMLElement);
    }
}
export const closeHamburger = () => {
    if (isHamburgerOpen()) {
        forceClick(document.getElementById('mobile-menu-button') as HTMLElement);
    }
}

export const openMessageBox = () => {
    if (!isMessageBoxOpen()) {
        forceClick(document.querySelector('.openMessageBoxButton') as HTMLElement);
    }
}
export const openInteractionBox = () => {
    if (!isInteractionOpen()) {
        forceClick(document.querySelector('.openInteractionBoxButton') as HTMLElement);
    }
}
export const closeMessageBox = () => {
    if (isMessageBoxOpen()) {
        forceClick(document.querySelector('.openMessageBoxButton') as HTMLElement);
    }
}
export const closeInteractionBox = () => {
    if (isInteractionOpen()) {
        forceClick(document.querySelector('.openInteractionBoxButton') as HTMLElement);
    }
}
//#endregion

export const tutorialFlowsMobile: Record<string, TutorialStepMobile[]> = {
    // 🧸 1️⃣ INTRO FLOW (Chose Guardian page)
    introFlow: [
        {
            title: `Cyborg Bear Introduction`,
            message: `Welcome to Scam Protect, I am Cyborg Bear, your guardian against scammers.
      I am here to assist you in all your anti-scam needs and to help you with scam identification 
      to keep you and your valuables safe.`,
            image: `cyborg-bear-1.png`,
        },
        {
            title: `Cyborg Bear Introduction`,
            message: `Since this is your first time using Scam Protect, let me orientate you towards the Scam Protect interface.
      You can go back to the previous instruction by clicking the "previous" button. To continue with the introduction, please click the "Pinging circle"`,
            image: `cyborg-bear-1.png`,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".tutorial-skip-btn-mobile",
            message: `You may skip the introduction by clicking on the “Skip Introduction” button at any time.`,
            image: `cyborg-bear-1.png`,
            isMustClick: true
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".guardian-arrow-right",
            message: `You can select to change your guardian later after this tutorial if you wish.`,
            image: `cyborg-bear-1.png`,
            isMustClick: true,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".choose-guardian-btn",
            message: `You can select to change your guardian later after this tutorial if you wish.`,
            image: `cyborg-bear-1.png`,
            isMustClickWithNoAction: true
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".openMessageBoxButton",
            message: `Click the Message button to open the Message Box.`,
            image: `cyborg-bear-1.png`,
            isMustClick: true,
            preExecuteWhenNext: ()=>{
                openMessageBox();
            }
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".MobileBottomPanel .guardian-communication-box",
            message: `Incoming communications from your requests or actions will be captured here.
      Your guardian will be your guide and companion.`,
            image: `cyborg-bear-1.png`,
            preExecuteWhenPrev: closeMessageBox
            // requiredDrawerOpen: DrawerIdMobile.MESSAGE,
            // elementMustClickBeforeNext: `.openMessageBoxButton`,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".MobileBottomPanel .incoming-message-box",
            message: `System messages that you may find useful will be displayed here. 
      We will keep you updated on important system messages here.`,
            image: `cyborg-bear-1.png`,
            // requiredDrawerOpen: DrawerIdMobile.MESSAGE,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".openMessageBoxButton",
            message: `Click the Message button again to close the Message Box.`,
            // requiredDrawerOpen: DrawerIdMobile.MESSAGE,
            // executeWhenNext: closeMessageBox,
            image: `cyborg-bear-1.png`,
            isMustClick: true,
            preExecuteWhenNext: closeMessageBox,
        }, {
            title: `Cyborg Bear Introduction`,
            selector: ".openInteractionBoxButton",
            message: `Click the Interaction button to open the Interaction Box.`,
            image: `cyborg-bear-1.png`,
            isMustClick: true,
            preExecuteWhenNext: openInteractionBox,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".MobileBottomPanel .interaction-interface-box",
            message: `This is the interaction interface.
      Your session history with your guardian will be recorded here for your easy reference.
      Saved files will be archived and can be used to send to external parties for scam reporting or analysis.`,
            image: `cyborg-bear-1.png`,
            // preExecuteWhenNext: openInteractionBox,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".MobileBottomPanel .save-history-btn",
            message: `If you would like to save your interaction history, please click the save button here.
      Saved interaction histories will go into the Archives.`,
            image: `cyborg-bear-1.png`,
            // requiredDrawerOpen: DrawerIdMobile.INTERACTION,
            isMustClickWithNoAction: true,
            // preExecuteWhenNext: ()=>{
            //     closeInteractionBox();
            // }

        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".openInteractionBoxButton",
            message: `Click the Interaction button again to close the Interaction Box.`,
            image: `cyborg-bear-1.png`,
            isMustClick: true,
            preExecuteWhenNext: ()=>{
                closeInteractionBox();
            }
        },
    ],

    // 🕵️ 2️⃣ SCAM IDENTIFY FLOW (StartIdentifyScam page)
    scamIdentifyFlow: [
        //   {
        //       message: `This page represents the scam identification function.
        // Options to guide you towards identifying potential scam scenarios will be displayed here.`,
        //       image: `cyborg-bear-1.png`,
        //   },

        // {
        //     title: `Cyborg Bear Introduction`,
        //     selector: ".top-menu-bar",
        //     message: `The Top menu bar offers options to bring up the functionality you wish to utilize in Scam Protect.`,
        //     image: `cyborg-bear-1.png`,
        // },
        {
            title: `Cyborg Bear Introduction`,
            selector: "#mobile-menu-button-container",
            message: `This is button to open the hamburger menu. When you click on it, you will find the options to navigate to the different functions of Scam Protect.`,
            image: `cyborg-bear-1.png`,
            isMustClick:true,
            preExecuteWhenPrev:openInteractionBox,
            preExecuteWhenNext:openHamburger
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: "#mobile-menu-list",
            message: `This is mobile hamburger menu. The Top menu bar offers options to bring up the functionality you wish to utilize in Scam Protect.`,
            image: `cyborg-bear-1.png`,

        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".mobile-menu-choose-guardian",
            message: `As you can see, it is currently displaying the "choose your guardian" functionality.`,
            image: `cyborg-bear-1.png`,
            isMustClickWithNoAction: true
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".mobile-menu-scam-identification",
            message: `Over here, Scam Protect uses The Wisdom Approach to create elemental fingerprints of “a lie” and “the truth” to accurately identify scams. 
            In many cases, it is possible to identify scams with complete accuracy. Once a scam is identified, you can protect yourself by avoiding it and reporting it to help others`,
            image: `cyborg-bear-1.png`,
            isMustClickWithNoAction: true,
            preExecuteWhenNext:closeHamburger,
            // isMustClick: true,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".fingerprint-scan-btn",
            message: `This page represents the scam identification function. `,
            // Your guardian will guide you towards obtaining information to identify any potential scam scenario you are facing. Information and options will be displayed in the centre once you start the scam identification process.
            // To start the scam identification process, simply click on the scam identification fingerprint`,
            image: `cyborg-bear-1.png`,
            // isMustClick: true,
            preExecuteWhenNext:openHamburger,
            isMustClickWithNoAction: true
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".mobile-menu-scam-education",
            message: `This is the Scam Education Tab, When completed, you will find materials that will educate and help you to protect yourself against scammers.`,
            isMustClick: true,
            image: `cyborg-bear-1.png`,
            hidePopover: true,
            // preExecuteWhenNext:closeHamburger,
        },
        //   {
        //       selector: ".disclaimer-ok-button",
        //       message: `After reading the disclaimer, click OK to continue.`,
        //       image: `cyborg-bear-1.png`,
        //   },
        //   {
        //       selector: ".center-question-box",
        //       message: `A separate scam identification tutorial will be made available for your benefit.
        // You can access it anytime from the main interface.`,
        //       image: `cyborg-bear-1.png`,
        //   },
    ],

    // 🎓 3️⃣ SCAM EDUCATION FLOW (/scam-education)
    scamEducationFlow: [
        {
            // selector: ".menu-scam-education",
            title: `Cyborg Bear Introduction`,
            message: `You are now in the “scam education” function. 
            This is where you can find information about scam statistics, and information that will help you gain capabilities to protect yourself from scams. 
            Explore this section to improve your scam-resistance level.`,
            image: `cyborg-bear-1.png`,
            preExecuteWhenPrev:openHamburger,
        },
        {
            title: `supper puppy Introduction`,
            // selector: ".menu-anti-scam-defenders",
            message: `Whenever you use Scam Protect more and explore its functions, including education, you can be awarded with achievement points and level up the Guardians protecting you`,
            image: `supper_puppy.png`,
            preExecuteWhenNext:openHamburger,
        },
        {
            title: `supper puppy Introduction`,
            selector: ".mobile-menu-anti-scam-defenders",
            message: `This is anti scam defenders.`,
            image: `supper_puppy.png`,
            isMustClick: true,
            hidePopover: true,
            // preExecuteWhenNext:openHamburger,
            // preExecuteWhenPrev:openHamburger,
        },
    ],

    // 🐻‍❄️ 4️⃣ ANTI SCAM DEFENDERS FLOW (/anti-scam-defenders)
    antiScamFlow: [
        {
            title: `The Twins - Kungfu Bears Introduction`,
            message: `You are now in the “anti-scam defences” function. 
            This is where scam protect uses Artificial Intelligence to utilized information collected to provide with scam blocking and filtering defences.
             You can also check for known scams that have been recorded in our databases and our affiliates’ databases. Please note that AI relies on data and cannot provide with full protection. 
             You should use our scam checking function if you have specific information like a phone number or email to check for known reported scams. 
            To protect yourself from any scam, we recommend using the scam identification function as this utilize a logic approach that is robust if the process is followed correctly.`,
            image: `kungfu_bear.png`,
            preExecuteWhenNext:openHamburger,
            preExecuteWhenPrev:openHamburger,
        },
        {
            title: `The Twins - Kungfu Bears Introduction`,
            selector: ".mobile-menu-contribution-community",
            message: `This is Contribution and community`,
            image: `kungfu_bear.png`,
            isMustClick: true,
            hidePopover: true,
            // preExecuteWhenNext:openHamburger,
            // preExecuteWhenPrev:openHamburger,
        },
    ],

    // 🐼 5️⃣ COMMUNITY FLOW (/contribution-community)
    communityFlow: [
        {
            title: `P & P Observation Unit: Poodie and Panda Introduction`,
            message: `You are now in the “contribution and community” function. 
            This is where you can access links to forums and communities talking about scams and how to protect oneself from scams. 
            You can also choose to “report a scam” here, or donate to vetted individuals and organizations actively trying to bring the fight to the scammers.`,
            image: `poodie_and_panda.png`,
            preExecuteWhenPrev:openHamburger,
        },
        {
            title: `Zombie Myles Introduction`,
            message: `I am Myles, Zombie Myles!
      When you help fight scammers, I will be there to GAAA the scammers into submission.`,
            image: `zombie-myles-1.png`,
            preExecuteWhenNext:openHamburger,
        },
        {
            title: `Zombie Myles Introduction`,
            selector: ".mobile-menu-archives",
            message: `This is the Archives function.`,
            image: `zombie-myles-1.png`,
            isMustClick: true,
            hidePopover: true,
        },
    ],

    // 📂 6️⃣ ARCHIVES FLOW (/archives)
    archivesFlow: [
        {
            title: `Cyborg Bear Introduction`,
            message: `This is the archives function. 
            All your saved interaction sessions will be displayed here according to a serial number, the date and time. 
            You can use the copy button to paste the text of each archive into messages for your desired purpose.`,
            image: `cyborg-bear-1.png`,
            preExecuteWhenPrev:openHamburger,
        },
        {
            title: `Cyborg Bear Introduction`,
            message: `This wraps up the tutorial for navigating scam protect. You can review the tutorial again whenever you desire. 
            The tutorial allows you to jump to specific sections of the tutorial for your convenience. 
            This means you are able to directly review the sections you need information about`,
            image: `cyborg-bear-1.png`,

        },
    ],
};

export function startTutorialFlowMobile(navigate: any, flowName: string, tutorialStep?: number) {
    navigate(getPageUrlForFlowMobile(flowName));
    localStorage.setItem(
        "tutorialProgressMobile",
        JSON.stringify({
            currentFlow: flowName,
            currentStep: tutorialStep ?? 0,
        })
    );
    localStorage.removeItem("hasCompletedTutorialMobile");
}

export const getPageUrlForFlowMobile = (flowName: string) => {
    switch (flowName) {
        case "introFlow":
            return "/choose-guardian";
        case "scamIdentifyFlow":
            return "/StartIdentifyScam";
        // return "/chose-guardian";
        case "scamEducationFlow":
            return "/scam-education";
        case "antiScamFlow":
            return "/anti-scam-defenders";
        case "communityFlow":
            return "/contribution-community";
        case "archivesFlow":
            return "/archives";
        default:
            return "/";
    }
};